export default "__VITE_ASSET__DuYjbIXI__"